import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DataGrid } from "../Layout/DataGrid";
import { Panel, PanelHeader } from "../Layout/Panel";
import { SortedListPagination } from "../Layout/SortedList";
import { getCustomer, getMillOrders, getPurchaseOrder } from "../../actions";
import { getIsLoadingSelector, getMillOrdersSelector } from "../../selectors/selectors";
import { withNavigationHistory } from "../Common/Navigation/withNavigationHistory";
import ColumnComponent from "./DataGrid/ColumnComponent";
import HeaderComponent from "./DataGrid/HeaderComponent";
import PanelTools from "./../Layout/Panel/PanelTools";

class GridPage extends PureComponent {
  static propTypes = {
    getCustomer: PropTypes.func.isRequired,
    getMillOrders: PropTypes.func.isRequired,
    getPurchaseOrder: PropTypes.func.isRequired,
    customerPOId: PropTypes.string,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    loadId: PropTypes.string,
    millOrders: PropTypes.array,
    routerParams: PropTypes.object,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    customerPOId: "",
    isLoading: false,
    isMobile: false,
    loadId: "",
    routerParams: {},
    millOrders: [],
    userMetadata: {}
  };

  state = {
    viewState: {
      currentPage: 1
    }
  };

  componentDidMount() {
    if (this.props.routerParams.customerId) {
      this.props.getCustomer(this.props.routerParams.customerId);
    }

    if (this.props.customerPOId) {
      this.props.getPurchaseOrder(this.props.customerPOId, {});
    }
  }

  handleChangeUnits = units => this.props.getMillOrders(this.props.routerParams.loadId, units);

  handleSetViewState = item => this.setState({ viewState: { ...this.state.viewState, ...item } });

  handleChangePagination = currentPage => this.handleSetViewState({ currentPage });

  render() {
    return (
      <Panel className="grid-page">
        <PanelHeader title={i18n.t("millOrder.load")} id={this.props.loadId} isMobile={this.props.isMobile} />
        <PanelTools className="--nosearch" isUnitsOfMeasureVisible changeUnits={this.handleChangeUnits} />
        <DataGrid
          ColumnComponent={ColumnComponent}
          HeaderComponent={HeaderComponent}
          onChangePagination={this.handleChangePagination}
          PaginationComponent={SortedListPagination}
          currentPage={this.state.viewState.currentPage}
          columnProps={{ routerParams: this.props.routerParams, userMetadata: this.props.userMetadata }}
          data={this.props.millOrders}
          itemsByPage={this.props.isMobile ? 1 : 4}
          isLoading={this.props.isLoading}
        />
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  const millOrders = getMillOrdersSelector(state);
  const firstMillOrder = _.first(millOrders) || {};

  return {
    customerPOId: state.app.routerParams.customerPOId,
    isLoading: getIsLoadingSelector(state, [getMillOrders.id]),
    isMobile: state.app.isMobile,
    loadId: firstMillOrder.loadId,
    routerParams: state.app.routerParams,
    millOrders,
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  { getCustomer, getMillOrders, getPurchaseOrder }
)(withNavigationHistory(GridPage));



// WEBPACK FOOTER //
// ./src/components/MillOrder/GridPage.js